var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dam-layout',[_c('base-listing',_vm._b({},'base-listing',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }